module.exports = __webpack_public_path__ + "img/noContent.ef691041.png";